export default __webpack_public_path__ + "static/media/net-left-background.6a26a791.svg";